// Isolated so tests can mock construction: `import.meta` doesn't compile under
// Jest's CJS transform, and rspack needs this exact static
// `new SharedWorker(new URL(...))` pattern to emit the worker chunk.
export const createSocketWorker = () =>
  new SharedWorker(new URL('./socketWorker.js', import.meta.url), {
    name: 'is-socket-worker',
    type: 'module',
  })
